import script from "./ChangelogSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangelogSidebar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__